export default number => {
  if (number) return `${number}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, x => `${x},`)
  else return '0'
}
